import { Directive, ElementRef } from '@angular/core';
import { fromEvent, Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Directive({ selector: 'ins-datepicker' })
export class InsDatepickerDirective {
    private readonly minWidth = 155;
    private destroy$ = new Subject<void>();
    private datepickerElm!: HTMLInsDatepickerElement;
    private inputElm!: HTMLInsInputElement | null | undefined;
    private resizeObservable$!: Observable<Event>;
    private initFormat!: Intl.DateTimeFormatOptions | undefined;
    private shortFormat: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
    };

    public constructor(private elmRef: ElementRef<HTMLInsDatepickerElement>) { }

    public async ngOnInit(): Promise<void> {
        this.datepickerElm = await this.elmRef.nativeElement.componentOnReady();
        this.datepickerElm.clearButton = this.datepickerElm.nullable;
        this.initFormat = this.datepickerElm.format;
        this.inputElm = this.datepickerElm.shadowRoot?.querySelector('ins-input');
        this.changeFormat();
        this.resizeObservable$ = fromEvent(window, 'resize');
        this.resizeObservable$.pipe(takeUntil(this.destroy$)).subscribe(_event => {
            this.changeFormat();
        });
    }

    public ngOnDestroy(): void {
        this.destroy$.next();
    }

    private changeFormat(): void {
        const offsetWidth = this.inputElm?.offsetWidth ?? 0;
        this.datepickerElm.format = offsetWidth > 0 && (offsetWidth < this.minWidth) ? this.shortFormat : this.initFormat;
    }
}
